"use client";

import React from "react";
import GenericSubstantiveProcedures from "../substantive-procedures/GenericSubstantiveProcedures";

interface SubstantiveProceduresProps {
  onBack?: () => void;
  setActiveSection?: (section: string) => void;
}

const WORKSPACE_NAME = "Employee Benefits Expense";

export default function SubstantiveProcedures({
  onBack,
  setActiveSection,
}: SubstantiveProceduresProps) {
  return (
    <GenericSubstantiveProcedures
      workspaceName={WORKSPACE_NAME}
      area="Execution"
      onBack={onBack}
      setActiveSection={setActiveSection}
    />
  );
}
